import React, { useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";

const Facility = () => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Header toggleSidebar={() => setOpen(true)} />
            <Sidebar isOpen={open} close={() => setOpen(false)} />
            {/* HERO */}
            <div className="about-hero">
                <div className="about-overlay">
                    <h1>FACILITY</h1>
                    <Breadcrumb />
                </div>
            </div>
            <div className="container contact-page">

                <div className="vision-card admission-card">

                    <h2 className="admission-title">
                        School Facilities
                    </h2>

                    <p className="facility-intro">
                        Nav Jeevan Mission School provides modern educational and sports
                        facilities to ensure the all-round development of every student.
                        The school focuses on academic excellence, physical fitness,
                        creativity, discipline, and personality development through
                        advanced infrastructure and co-curricular activities.
                    </p>

                    {/* FACILITY GRID */}
                    <div className="facility-grid">

                        {/* COMPUTER LAB */}
                        <div className="facility-box">
                            <h3>Computer Lab</h3>
                            <p>
                                Advanced computer lab with modern systems and internet
                                facilities for digital learning.
                            </p>
                        </div>

                        {/* SCIENCE LAB */}
                        <div className="facility-box">
                            <h3>Science Laboratories</h3>
                            <p>
                                Well-equipped Physics, Chemistry, and Biology labs
                                for practical learning and experiments.
                            </p>
                        </div>

                        {/* LIBRARY */}
                        <div className="facility-box">
                            <h3>Library</h3>
                            <p>
                                A rich collection of books, journals, and digital
                                resources to encourage reading habits.
                            </p>
                        </div>

                        {/* FOOTBALL */}
                        <div className="facility-box">
                            <h3>Football Ground</h3>
                            <p>
                                Spacious football ground for sports training,
                                tournaments, and physical fitness.
                            </p>
                        </div>

                        {/* BADMINTON */}
                        <div className="facility-box">
                            <h3>Badminton Court</h3>
                            <p>
                                Professional badminton facilities to enhance
                                student sports participation and teamwork.
                            </p>
                        </div>

                        {/* VOLLEYBALL */}
                        <div className="facility-box">
                            <h3>Volleyball Court</h3>
                            <p>
                                Dedicated volleyball court for inter-house
                                competitions and regular practice sessions.
                            </p>
                        </div>

                        {/* KABADDI */}
                        <div className="facility-box">
                            <h3>Kabaddi</h3>
                            <p>
                                Traditional sports activities that develop
                                stamina, teamwork, and confidence among students.
                            </p>
                        </div>

                        {/* KHO KHO */}
                        <div className="facility-box">
                            <h3>Kho Kho</h3>
                            <p>
                                Outdoor sports activities that improve agility,
                                discipline, and physical strength.
                            </p>
                        </div>

                    </div>

                </div>

            </div>

            <Footer />
        </>
    );
};

export default Facility;